import { Component, OnInit } from '@angular/core';
import {StoryboardEditComponent} from "../../storyboard/storyboard-edit/storyboard-edit.component";
import {StoryboardService} from "../../storyboard/shared/storyboard.service";
import {ActivatedRoute} from "@angular/router";
import {TemplateService} from "../shared/template.service";
import {Template} from "../shared/template";
import { TimelineService } from 'app/storyboard/storyboard-edit/timeline/timeline.service';

@Component({
  selector: 'app-template-edit',
  templateUrl: './template-edit.component.html',
  styleUrls: ['./template-edit.component.scss']
})
export class TemplateEditComponent extends StoryboardEditComponent implements OnInit {

  item: Template;

  constructor(
    protected storyboardService: StoryboardService,
    protected timelineService: TimelineService,
    protected route: ActivatedRoute, 
    protected templateService: TemplateService) {
    super(storyboardService, timelineService, route);
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.itemId = +params['id']; // (+) converts string 'id' to a number
      this.getItem(this.itemId);
    });
  }

  protected getItem(itemId: number): void {

    this.itemLoading = true;

    this.templateService.getTemplate(itemId).then(item => {

      this.item = item;

      this.itemLoading = false;
    }, () => {
      this.itemLoading = false;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/template/template-edit/template-edit.component.ts